$('.btn-export').on('click', function () {
    showExportModal().then();
});

async function showExportModal() {
    const plantId = $("#plant-id").val();
    const orderId = $("#order_id").val();
    const selectedDocumentIds = getSelectedDocumentIds();

    const dataString = JSON.stringify({
        'orderId': orderId,
        'selectedSearchId': getSelectedSearchId(),
        'selectedDocumentIds': selectedDocumentIds
    });

    const data = await $.get(`/plants/${plantId}/exports?orderId=${orderId}`);
    $("#export-modal-content").html(data);
    $('.export-modal-metadata').val(dataString);
    mapExportEvents();
    fillDefaultMargins();
    $('#export-modal').modal('show');
}

function fillDefaultMargins() {
    const plantId = $("#plant-id").val();
    $.get(`/plants/${plantId}/exports/margins`, function (data) {
        JSON.stringify(data);
        if (data['margins']) {
            $('#exportType_marginTop').val(data['margins'].top);
            $('#exportType_marginBottom').val(data['margins'].bottom);
            $('#exportType_marginRight').val(data['margins'].right);
            $('#exportType_marginLeft').val(data['margins'].left);
        }
    });
}

function mapExportEvents() {
    const exportFormatGroup = $("input:radio[name='exportType[exportFormat]']");
    const chainSheetOptionsSection = $('.chain-sheet-options-section');
    const customMarginsCheckbox = $('#exportType_setMargins');
    const customMarginsSection = $('.custom-margin-section');
/* //kept in case a ui is desired for background shading
    if(document.getElementById("checkbox-related").checked) {
        document.getElementById("exportType_chainSheetOptions_docRelatedColor").checked = true;
    }
    if(document.getElementById("checkbox-primary").checked) {
        document.getElementById("exportType_chainSheetOptions_docPrimaryColor").checked = true;
    }*/

    exportFormatGroup.on('change', function () {
        const selectedOption = getSelectedExportFormat();

        if (selectedOption === 'email') {
            $('.email-form-section').removeClass('collapse');
        } else {
            $('.email-form-section').addClass('collapse');
        }

        const sectionsDiv = $('.sections-to-include-section');
        const sectionCheckboxes = sectionsDiv.find('input');
        const sectionLabels = sectionsDiv.find('label');
        const customMarginsCheckboxSection = $('.custom-margins-checkbox-section');
        const otherFormatSection = $('.other-format-section');

        if (selectedOption === 'links' || selectedOption === 'zip' || selectedOption === 'other') {
            sectionCheckboxes.prop('disabled', true);
            sectionCheckboxes.prop('checked', false);
            sectionLabels.addClass('text-muted');
            sectionLabels.parent().addClass('text-muted');
            addRemoveNotes($('#exportType_includeChainSheet').is(":checked"));
            chainSheetOptionsSection.addClass('collapse');
        } else {
            sectionCheckboxes.prop('disabled', false);
            sectionLabels.removeClass('text-muted');
            sectionLabels.parent().removeClass('text-muted');
            addRemoveNotes($('#exportType_includeChainSheet').is(":checked"));
        }

        if (selectedOption === 'other') {
            otherFormatSection.removeClass('collapse');
            customMarginsCheckboxSection.addClass('collapse');
            customMarginsCheckboxSection.addClass('collapse');
            customMarginsSection.addClass('collapse');
            customMarginsCheckbox.prop('checked', false);
        } else {
            otherFormatSection.addClass('collapse');
            customMarginsCheckboxSection.removeClass('collapse');
            customMarginsCheckboxSection.removeClass('collapse');
        }
    });

    $('#exportType_includeChainSheet').on('change', function () {
        if (this.checked) {
            chainSheetOptionsSection.removeClass('collapse');
        } else {
            chainSheetOptionsSection.addClass('collapse');
        }
    });

    customMarginsCheckbox.on('click', function () {
        if (this.checked) {
            customMarginsSection.removeClass('collapse');
        } else {
            customMarginsSection.addClass('collapse');
        }
    });

    $(".margins").blur(function () {
        if ($(this).val().includes('/')) {
            const number = parseInt($(this).val().split('/')[0]) / parseInt($(this).val().split('/')[1]);
            $(this).val(number);
        }
    });

    $(".margins").on('keyup', function () {
        if ($(this).val().charAt(0) === '.') {
            $(this).val('0' + $(this).val());
        }
    });

    addRemoveFallout(false);// fallout should be greyed out at the start
    var DocsToExport = $("input:radio[name='exportType[documentSelection]']");
    DocsToExport.on('change', function () {
        var selected = getSelectedDocumentsToExport();

        if (selected === 'allTabs') {
            addRemoveFallout(true);
            addIncludeAdditionalInfo(true);
        } else {
            addRemoveFallout(false);
            addIncludeAdditionalInfo(false);
        }
    });

    $('#exportType_includeChainSheet').click(function () {
        addRemoveNotes(this.checked);
        if (getSelectedDocumentsToExport() === 'allTabs') {
            addRemoveFallout(this.checked);
            addIncludeAdditionalInfo(this.checked);
        }
    });

    exportFormatGroup.trigger('change');

    $('.export-submit-btn').on('click', function (e) {
        e.preventDefault();
        var selectedOption = getSelectedExportFormat();
        var exportModal = $('#export-modal');
        var exportForm = exportModal.find('form');
        if (selectedOption === 'email') {
            e.preventDefault();
            exportForm.attr('target', '');
            $("#export-modal-content").html('<div class="text-center">Sending Email</div>');

            $.post(exportForm.attr('action'), exportForm.serialize(), function (data) {
                $("#export-modal-content").html(data);
            })
        } else if (selectedOption === 'links') {
            e.preventDefault();
            exportForm.attr('target', '');
            $("#export-modal-content").html('<div class="text-center">Compiling links</div>');

            $.post(exportForm.attr('action'), exportForm.serialize(), function (data) {
                $("#export-modal-content").html(data);
            })
        } else {
            exportForm.submit();
            exportModal.modal('hide');
        }
    });
}

function addRemoveFallout(checked) {
    var falloutCheckbox = $('#exportType_excludeFalloutTab');
    if (checked) {
        falloutCheckbox.prop('disabled', false);
        falloutCheckbox.removeClass('text-muted');
        falloutCheckbox.parent().removeClass('text-muted');
    } else {
        falloutCheckbox.prop('checked', false);
        falloutCheckbox.prop('disabled', true);
        falloutCheckbox.addClass('text-muted');
        falloutCheckbox.parent().addClass('text-muted');
    }
}

function addRemoveNotes(checked) {
    var notesDiv = $('.notes-section');
    var notesCheckboxes = notesDiv.find('input');
    if (checked) {
        notesCheckboxes.prop('disabled', false);
        notesCheckboxes.removeClass('text-muted');
        notesCheckboxes.parent().removeClass('text-muted');
    } else {
        notesCheckboxes.prop('checked', false);
        notesCheckboxes.prop('disabled', true);
        notesCheckboxes.addClass('text-muted');
        notesCheckboxes.parent().addClass('text-muted');
    }
}

function addIncludeAdditionalInfo(checked) {
    var additionalInfoCheckbox = $('#exportType_includeAdditionalInfoTab');

    additionalInfoCheckbox.prop('checked', checked);
}

function getSelectedExportFormat() {
    return $("input:radio[name='exportType[exportFormat]']:checked").val();
}

function getSelectedDocumentsToExport() {
    return $("input:radio[name='exportType[documentSelection]']:checked").val();
}
